import React from "react";
import HindiSection from  "./HindiSection.js"
import EnglishSection from "./EnglishSection.js";

const MainSection = ({language}) => {
  return (
    <>
 {language === "English" ? <EnglishSection /> : <HindiSection />}
    </>
  );
};    
export default MainSection;


